/* Formato de importes con la divisa de la FACTURA (nunca € fijo).
 *
 * La divisa viaja en los args del interrupt (`moneda`, código ISO derivado del
 * proveedor en X3 y EDITABLE por el revisor) y, en resueltas, en `result.moneda`
 * (la realmente posteada en X3). Sin divisa conocida el importe se muestra sin
 * sufijo: no asumimos EUR (las facturas de proveedores extranjeros van en
 * USD/GBP/...). Módulo propio — no en el .tsx del componente — por la regla
 * eslint `react-refresh/only-export-components` y para compartirlo con summary.ts.
 */

/** Normaliza un valor de divisa a código ISO en mayúsculas ("" si no hay). */
export function normalizeCurrency(value: unknown): string {
  return typeof value === "string" ? value.trim().toUpperCase() : "";
}

/** Formatea un número en es-ES (coma decimal) con la divisa: 1234.5 -> "1.234,50 USD". */
export function formatMoney(value: number, currency: string): string {
  const num = value.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency ? `${num} ${currency}` : num;
}

/** Añade la divisa a un importe YA formateado: "478,80" -> "478,80 USD". */
export function withCurrency(display: string, currency: string): string {
  if (!display) return display;
  return currency ? `${display} ${currency}` : display;
}
